import React from 'react';

import {MainLayout} from 'widgets/layout';
import {listPageClassName} from 'shared/ui/ListPage/ListPage';
import NotFoundPage from 'shared/ui/ErrorPage/NotFoundPage';
import {useHttpMonitorLogsScreen, HttpMonitorLogs} from 'features/http';

const HttpMonitorLogsPage: React.FC = () => {
    const {monitor, isNotFound} = useHttpMonitorLogsScreen();

    if (isNotFound) {
        return <NotFoundPage/>;
    }

    if (!monitor) {
        return <></>;
    }

    return (
        <MainLayout className={listPageClassName}>
            <HttpMonitorLogs monitor={monitor}/>
        </MainLayout>
    );
};

export default HttpMonitorLogsPage;
